<div class="field-wrap">
  <ng-icon name="lucideSearch" class="field-icon" aria-hidden="true" />
  <input
    #field
    class="evo-input field"
    type="search"
    role="combobox"
    autocomplete="off"
    aria-autocomplete="list"
    [id]="uid + '-field'"
    [attr.aria-controls]="uid + '-results'"
    [attr.aria-expanded]="airports.length > 0"
    [attr.aria-activedescendant]="highlighted >= 0 ? uid + '-option-' + highlighted : null"
    [placeholder]="placeholder()"
    (input)="onInput($any($event.target).value)"
    (keydown)="onKeydown($event)" />
</div>

@if (query) {
  <div class="results" role="listbox" [id]="uid + '-results'">
    @if (airportSearchPending) {
      @for (row of skeletonRows; track row) {
        <div class="evo-skeleton evo-skeleton--line result-skeleton"></div>
      }
    } @else if (airportSearchFailed) {
      <p class="state">Search is not responding. Try again in a moment.</p>
    } @else if (airports.length === 0) {
      <p class="state">No airport matches “{{ query }}”.</p>
    } @else {
      @for (airport of airports; track airport.id; let i = $index) {
        <button
          type="button"
          role="option"
          class="result"
          data-testid="search-result"
          [id]="uid + '-option-' + i"
          [class.highlighted]="i === highlighted"
          [attr.aria-selected]="i === highlighted"
          (click)="choose(airport)">
          <span class="code data">{{ airport.icao }}</span>
          <span class="name">{{ airport.name }}</span>
          <span class="place">{{ airport.city }}</span>
        </button>
      }
    }
  </div>
}
